export default __webpack_public_path__ + "static/media/hi-webapp.16de7748.png";